import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import autoBind from 'react-autobind'
import { SketchPicker } from 'react-color'
import { rgb } from 'd3-color'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import styles from './ColorPanel.css'

// TODO: (2) Connect component to redux store

// Layer color class by type
const colorClass = {
  line: 'line-color',
  fill: 'fill-color',
  background: 'background-color',
  symbol: 'text-color',
}

/**
 * Allows to dynamically adjust Mapbox style colors
 */
class ColorPanel extends PureComponent {
  static propTypes = {
    mapStyle: PropTypes.object,
  }

  static defaultProps = {
    mapStyle: { layers: [] },
  }

  constructor(props) {
    super(props)
    autoBind(this)

    this.state = {
      mapStyle: null,
    }
  }

  // FEATURE: (2) Sync mapStyle via redux state
  static getDerivedStateFromProps({ mapStyle }, prevState) {
    if (prevState.mapStyle !== mapStyle) {
      const layerMap = _.keyBy(mapStyle.layers, 'id')
      const color = _.mapValues(
        layerMap,
        ({ paint, type, id }) => paint[colorClass[type]] || '#000'
      )
      const visibility = _.mapValues(layerMap, x => true)
      const picker = _.mapValues(layerMap, x => false)

      return {
        color,
        visibility,
        picker,
        mapStyle,
      }
    }
    return null
  }

  handleSwatchClick(id) {
    this.setState({
      picker: _.mapValues(this.state.picker, (value, key) => key === id),
    })
  }

  emitChange() {
    this.props.onChange({ layers: this.getUpdatedLayers() })
  }

  handleColorChange({ id, color: c }) {
    const color = { ...this.state.color, [id]: c }
    this.setState({ color }, () => this.emitChange())
  }

  handleVisibilityChange(id) {
    const visibility = {
      ...this.state.visibility,
      [id]: !this.state.visibility[id],
    }
    this.setState({ visibility }, () => this.emitChange())
  }

  handleToggleAll() {
    const { visibility } = this.state
    const allVisible = _.every(_.values(visibility))
    this.setState(
      { visibility: _.mapValues(visibility, () => !allVisible) },
      () => this.emitChange()
    )
  }

  getUpdatedLayers() {
    const { color, visibility } = this.state
    return this.props.mapStyle.layers
      .filter(({ id }) => visibility[id])
      .map(layer => {
        const { id, type, paint } = layer
        if (colorClass[type]) {
          return {
            ...layer,
            paint: { ...paint, [colorClass[type]]: color[id] },
          }
        }
        return layer
      })
  }

  renderLayerControl() {
    const { visibility, color, picker } = this.state
    return this.props.mapStyle.layers.map(({ id }) => (
      <div key={id}>
        <div className={styles.Input}>
          <label className={styles.Label}>{id}</label>
          <input
            type="checkbox"
            checked={visibility[id]}
            onChange={() => this.handleVisibilityChange(id)}
          />
          <div
            className={styles.Swatch}
            onClick={() => this.handleSwatchClick(id)}
          >
            <div className={styles.Color} style={{ background: color[id] }} />
          </div>
        </div>
        {picker[id] && (
          <SketchPicker
            color={color[id]}
            presetColors={[
              '#fb8799',
              '#b193f3',
              '#88c3fc',
              '#fbd769',
              '#87fcc2',
              '#fff',
              '#f6f5fa',
              '#a39db0',
              '#665f77',
            ]}
            onChange={({ rgb: { r, g, b, a } }) => {
              this.handleColorChange({ id, color: rgb(r, g, b, a).toString() })
            }}
          />
        )}
      </div>
    ))
  }

  render() {
    return (
      <div className={styles.Panel}>
        {this.renderLayerControl()}
        <CopyToClipboard text={JSON.stringify(this.state, null, ' ')}>
          <button>Copy to clipboard</button>
        </CopyToClipboard>
        <button onClick={this.handleToggleAll}>Toggle</button>
      </div>
    )
  }
}

export default ColorPanel
